export default {
  LOAD_DESIGNATION_OVERVIEW_PAGE_START: 'LoadDesignationOverviewPageStart',
  LOAD_DESIGNATION_OVERVIEW_PAGE_END: 'LoadDesignationOverviewPageEnd',
  APPROVE_DESIGNATION_START: 'ApproveDesignationStart',
  APPROVE_DESIGNATION_END: 'ApproveDesignationEnd',
  UNAPPROVE_DESIGNATION_START: 'UnapproveDesignationStart',
  UNAPPROVE_DESIGNATION_END: 'UnapproveDesignationEnd',
  CLEANUP_DESIGNATION_OVERVIEW_PAGE: 'CleanupDesignationOverviewPage',
  TOGGLE_DESIGNATION_CONFIRM_DIALOG: 'ToggleDesignationConfirmDialog',
  SUBMIT_DESIGNATION_START: 'SubmitDesignationStart',
  SUBMIT_DESIGNATION_END: 'SubmitDesignationEnd',
  RESUBMIT_DESIGNATION_START: 'ResubmitDesignationStart',
  RESUBMIT_DESIGNATION_END: 'ResubmitDesignationEnd',
  REMOVE_DESIGNATION_START: 'RemoveDesignationStart',
  REMOVE_DESIGNATION_END: 'RemoveDesignationEnd',
  CANCEL_DESIGNATION_START: 'CancelDesignationStart',
  CANCEL_DESIGNATION_END: 'CancelDesignationEnd'
};